/**
 *
 * MeasurementCreate
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import { Button, Steps, Input, Tooltip, Popover } from "antd"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import ModalCustom from "components/ModalCustom"
import Loader from "components/Loader"
import MeasurementSelectRecipient from "components/MeasurementSelectRecipient"
import MeasurementPreview from "components/MeasurementPreview"
import MeasurementScheduleSurvey from "components/MeasurementScheduleSurvey"
import SelectLeadershipRecipients from "components/SelectLeadershipRecipients"
import ModalSendTestSurvey from "components/ModalSendTestSurvey"
import ModalEditMeasure from "components/ModalEditMeasure"
import { pick, get, has, isEqual, uniq } from "lodash"
import reducer from "./reducer"
import saga from "./saga"

import {
  getDivisionsWatcher,
  getDescendantsWatcher,
  // postLogoEmailWatcher,
  // postImageEmailWatcher,
  stepOneWatcher,
  stepTwoWatcher,
  stepThirdWatcher,
  stepFourthWatcher,
  stepFinishWatcher,
  stepMailWatcher,
  stepRecipientsWatcher,
  stepDatacheckWatcher,
  stepPreviewWatcher,
  stepScheduleWatcher,
  stepCompleteWatcher,
  editMeasurementNameWatcher,
  stepOneSuccess,
  postLogoEmailSuccess,
  postImageEmailSuccess,
  getLeadersWatcher,
  getSurveysTypeWatcher,
  getMeasureWatcher,
  updateMeasureWatcher,
  getSegmentsWatcher,
  getScopeTypesWatcher,
  getSurveyTypesWatcher,
  getOrganizationSurveysWatcher,
  getSegmentsSurveysWatcher,
  forceSaveWatcher,
  getEmployeesBySegmentsWatcher,
} from "./actions"
import {
  makeSelectIsLoadingDivisions,
  makeSelectDivisions,
  makeSelectIsLoadingDescendents,
  makeSelectDescendents,
  makeSelectIsLoadingLogoUrl,
  makeSelectLogoUrl,
  makeSelectIsLoadingImageUrl,
  makeSelectImageUrl,
  makeSelectNameMeasurement,
  makeSelectMailStepData,
  makeSelectIsLoadingMailStepData,
  makeSelectRecipientsStepData,
  makeSelectIsLoadingRecipientsStepData,
  makeSelectDataCheckStepData,
  makeSelectIsLoadingDataCheckStepData,
  makeSelectPreviewStepData,
  makeSelectIsLoadingPreviewStepData,
  makeSelectScheduleStepData,
  makeSelectIsLoadingScheduleStepData,
  makeSelectCompleteStepData,
  makeSelectIsLoadingCompleteStepData,
  makeSelectFirstStepData,
  makeSelectIsLoadingFirstStepData,
  makeSelectSecondStepData,
  makeSelectIsLoadingSecondStepData,
  makeSelectFourthStepData,
  makeSelectIsLoadingFourthStepData,
  makeSelectGetLeaders,
  makeSelectIsLoadingGetLeaders,
  makeSelectIsLoadingSurveysType,
  makeSelectSurveysType,
  makeSelectGetMeasure,
  makeSelectIsLoadingMeasure,
  makeSelectIsLoadingUpdateMeasure,
  makeSelectSegments,
  makeSelectIsLoadingSegments,
  makeSelectSurveyTypes,
  makeSelectIsLoadingSurveyTypes,
  makeSelectScopeTypes,
  makeSelectIsLoadingScopeTypes,
  makeSelectOrganizationSurveys,
  makeSelectIsLoadingOrganizationSurveys,
  makeSelectSegmentsSurveys,
  makeSelectIsLoadingSegmentsSurveys,
  makeSelectForceSaveData,
  makeSelectIsLoadingForceSaveData,
  makeSelectEmployeesBySegments,
  makeSelectIsLoadingEmployeesBySegments,
} from "./selectors"

// import Layout from 'components/Layout';

import {
  setupMailMeasureSegment,
  selectCollaboratorMeasureSegment,
  editMailMeasureSegment,
  previewMeasureSegment,
  sendMeasureSegment,
  getDaysFrequencyRange,
  programMeasureSegment,
  editScheduleMeasureSegment,
} from "../../../utils/segment/Measure/measureTrack"

import previewIcon from "../../../images/preview-icon.svg"
import sendProofIcon from "../../../images/send-proof-icon.svg"
import saveCardIcon from "../../../images/save-card.svg"
import alertSvg from "../../../images/alert.svg"
import check from "../../../images/check.svg"
import pencilGray from "../../../images/pencil-gray.svg"

import "react-quill/dist/quill.snow.css"
import MailConfiguration from "../MailConfiguration"
import "./index.less"
import { LeftOutlined, RightOutlined } from "@ant-design/icons"
import { woopraTrack } from "../../../utils/woopra/woopraTracker"
import MeasureEdit from "../../../components/MeasureEdit"
import MeasureDataCheck from "../../../components/MeasureDataCheck"
import { LOCAL_COMPANY_ID, LOCAL_USER_ID } from "../../../utils/storage"
import MeasureSelectRecipientsSegments from "../../../components/MeasureSelectRecipientsSegments"
import { buttonAction } from "../../../components/Snowplow/config"
import { TYPE_SURVEY } from "../../../utils/constants"
import {
  buttonAction_btns,
  buttonAction_s,
} from "../../../components/Snowplow/config2"

const { Step } = Steps
/* eslint-disable react/prefer-stateless-function */
export class MeasurementCreate extends React.Component {
  state = {
    currentStep: 0,
    sendProofModal: false,
    idMeasurement: undefined,
    modalButtonBackHistory: false,
    modalButtonFinish: false,
    email_subject: "",
    email_text_length: 0,
    email_button_text: 0,
    date_start: false,
    date_end: false,
    hour_send: false,
    days_resend: false,
    hour_rensend: false,
    divisionsSelected: [],
    collaboratorsSelected: [],
    stepFourthReSend: {},

    modalSendTestSurvey: false,
    modalEditMeasure: false,

    showChangeSave: false,
    editMeasureSegment: [],
    isPreview: false,
    isSend: false,
    firstStepValidation: false,

    isSavingConfiguration: false,
    nameSaving: "",

    nameMeasure: "",
    surveyType: 1,
    scopeType: 1,
    measureType: 1,
    selectedSegments: [],
    selectedSurvey: undefined,
    segmentsAndSurveys: [],

    employeesAndSurveys: [],
    selectedEmployees: [],
  }

  componentDidMount = () => {
    const {
      match: { params },
    } = this.props

    const search = window.location.search
    const queryParams = new URLSearchParams(search)
    const newStep = queryParams.get("step")

    if (newStep) {
      this.props.history.push(`/models/measure-create/${params.id}`)
      setTimeout(() => this.nextStep(+newStep - 1), 1000)
    }

    this.props.getMeasureWatcher(params.id)
    this.props.getSurveyTypesWatcher()
    this.props.getScopeTypesWatcher()

    // this.props.stepDatacheckWatcher({ idMeasurement: params.id })

    // this.props.stepOneWatcher({ idMeasurement: params.id })
    this.props.stepMailWatcher({ idMeasure: params.id })
    // this.props.stepTwoWatcher({ idMeasurement: params.id })
    this.props.stepRecipientsWatcher({ idMeasurement: params.id })
    // this.props.stepFourthWatcher({ idMeasurement: params.id })
    this.props.stepScheduleWatcher({ idMeasurement: params.id })
    // this.props.postLogoEmailWatcher({ idMeasurement: params.id, type: 'logo' })
    this.props.getDivisionsWatcher()
    // this.props.postImageEmailWatcher({ idMeasurement: params.id, type: 'image' })
    this.setState({ idMeasurement: params.id })
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (!isEqual(prevProps.firstStepData, this.props.firstStepData)) {
      this.props.getSurveysTypeWatcher(this.props.firstStepData.id_survey_type)
    }

    if (
      !isEqual(prevState.currentStep, this.state.currentStep) &&
      this.state.currentStep === 2
    ) {
      this.props.stepRecipientsWatcher({
        idMeasurement: this.state.idMeasurement,
      })
    }

    if (
      !isEqual(prevProps.measure, this.props.measure) &&
      this.props.measure.id_survey_type
    ) {
      this.props.getOrganizationSurveysWatcher(
        this.props.measure.id_survey_type
      )
      this.props.getSegmentsWatcher(this.props.measure.id_survey_type)
      let selectedSeg = []
      if (this.props.measure.segments) {
        selectedSeg = this.props.measure.segments.map(
          (segment) => segment.id_segment
        )
        this.setState({
          selectedSegments: selectedSeg,
          segmentsAndSurveys: this.props.measure.segments,
        })
      }

      if (this.props.measure.id_survey)
        this.setState({ selectedSurvey: this.props.measure.id_survey })
      this.setState({
        nameMeasure: this.props.measure.name,
        surveyType: this.props.measure.id_survey_type,
        scopeType: this.props.measure.id_scope_type,
        measureType: this.props.measure.id_measure_type || 1,
      })
    }

    if (!isEqual(prevState.surveyType, this.state.surveyType)) {
      this.props.getOrganizationSurveysWatcher(this.state.surveyType)
      this.props.getSegmentsWatcher(this.state.surveyType)
    }
  }

  componentWillUnmount = () => {
    this.props.stepOneSuccess({})
    this.props.postLogoEmailSuccess("")
    this.props.postImageEmailSuccess("")
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  saveSettingSegment = (name, isEqualAttribute) => {
    const { editMeasureSegment } = this.state
    const index = editMeasureSegment.indexOf(name)
    if (
      ((isEqualAttribute === false || isEqualAttribute === "delete") &&
        index == -1) ||
      isEqualAttribute === "update"
    ) {
      editMeasureSegment.push(name)
    }
    if ((isEqualAttribute || isEqualAttribute === "delete") && index != -1) {
      editMeasureSegment.splice(index, 1)
    }
    this.setState({ editMeasureSegment })
  }

  isPrevieworSend = (action) => {
    if (action === "preview") {
      this.setState({ isPreview: true })
    } else if (action === "send") {
      this.setState({ isSend: true })
    }
  }

  programmOrEditMeasureSegment = () => {
    const nameMeasure = get(this.props, "nameMeasurement", "")
    if (this.props.measure.id_measure_status === 1) {
      const attempts = getDaysFrequencyRange(
        this.state.stepFourthReSend.params.date_resend,
        this.state.date_start,
        this.state.date_end
      )
      programMeasureSegment(
        nameMeasure,
        this.state.date_start,
        this.state.date_end,
        this.state.hour_send,
        attempts,
        this.state.stepFourthReSend.params.date_resend
      )
    } else {
      editScheduleMeasureSegment(
        nameMeasure,
        this.state.editMeasureSegment,
        this.state.stepFourthReSend.params.date_resend
      )
    }
  }

  nextStep = (num = 1) => {
    const step = this.state.currentStep + num
    const nameMeasure = get(this.props, "nameMeasurement", "")
    if (num > 0) {
      switch (step) {
        case 1:
          const { editMeasureSegment } = this.state
          setupMailMeasureSegment(nameMeasure)
          if (editMeasureSegment.length > 0) {
            editMailMeasureSegment(nameMeasure, editMeasureSegment)
            this.setState({ editMeasureSegment: [] })
          }
          break
        case 2:
          const { collaboratorsSelected } = this.state
          selectCollaboratorMeasureSegment(
            nameMeasure,
            collaboratorsSelected.length
          )
          break
        case 3:
          const { isPreview, isSend } = this.state
          previewMeasureSegment(nameMeasure, isPreview)
          if (isSend) {
            // sendMeasureSegment(nameMeasure);
          }
          break
      }
    }
    this.setState({ currentStep: this.state.currentStep + num })
  }

  // snowplow
  buttonAction_btn = (tipo) => {
    let data_button_prev = {
      category: window.location.hash
        ? window.location.hash
        : window.location.pathname,
      action: tipo,
      label: `Click a ${tipo}`,
      property: "button",
      value: LOCAL_USER_ID(),
    }
    buttonAction_s(data_button_prev)
  }

  validateFields = () => {
    if (this.state.currentStep === 0) {
      if (this.state.nameMeasure === "") {
        return true
      }

      if (this.state.scopeType === 1) {
        if (!this.state.selectedSurvey) {
          return true
        }
      }

      if (this.state.scopeType === 2) {
        if (this.state.selectedSegments.length === 0) {
          return true
        }

        if (
          this.state.selectedSegments.length !==
          this.state.segmentsAndSurveys.length
        ) {
          return true
        }
      }
    }

    if (
      this.state.currentStep === 3 &&
      this.props.measure.id_scope_type === 2
    ) {
      if (
        this.props.datacheckStepData.length !==
        this.state.employeesAndSurveys.length
      ) {
        return true
      }
    }

    return false
  }

  disableNextStep = () => {
    if (this.state.currentStep === 2) {
      if (this.state.scopeType === 1) {
        if (this.state.selectedEmployees) {
          return !this.state.selectedEmployees.length
        }
        if (this.state.collaboratorsSelected) {
          return !this.state.collaboratorsSelected.length
        }
      } else {
        if (this.state.selectedEmployees) {
          return !this.state.selectedEmployees.length
        }
      }

      return true
    }

    if (
      (this.state.currentStep === 4 &&
        this.props.measure.id_scope_type === 1) ||
      (this.state.currentStep === 5 && this.props.measure.id_scope_type === 2)
    ) {
      return (
        !this.state.date_start ||
        !this.state.date_end ||
        !this.state.hour_send ||
        this.state.days_resend ||
        this.state.hour_resend ||
        !this.state.hour_close
      )
    }

    return false
  }

  renderAutosaveLoader = () => {
    if (!this.props.firstStepData.name) return null

    // if (this.props.isLoadingFirstStepData || this.props.isLoadingSecondStepData || this.props.isLoadingFourthStepData) {
    if (
      this.state.isSavingConfiguration ||
      this.props.isLoadingSecondStepData ||
      this.props.isLoadingFourthStepData
    ) {
      return (
        <React.Fragment>
          <div className="loader-autosave">
            <div />
            <div />
            <div />
            <div />
          </div>
          Guardando
        </React.Fragment>
      )
    }
    if (this.state.nameSaving) {
      setTimeout(() => this.setState({ nameSaving: "" }), 1500)
    }

    return this.state.nameSaving
  }

  saveMeasure = () => {
    let body = {
      id_company: Number(LOCAL_COMPANY_ID()),
      id_measure: this.props.measure.id_measure,
      id_scope_type: this.state.scopeType,
      id_survey_type: this.state.surveyType,
      id_measure_type: this.state.measureType,
      name: this.state.nameMeasure,
      metric_total_label:
        this.state.surveyType === 1 ? "Clima laboral" : "Liderazgo",
    }

    if (this.state.scopeType === 1) {
      body = {
        ...body,
        id_survey: this.state.selectedSurvey,
      }
    }
    if (this.state.scopeType === 2) {
      body = {
        ...body,
        id_survey: null,
        segments_has_surveys: this.state.segmentsAndSurveys,
      }
    }

    this.props.updateMeasureWatcher(body)
  }

  saveRecipients = () => {
    this.props.stepRecipientsWatcher({
      idMeasurement: this.state.idMeasurement,
      params: {
        auto_save: true,
        employees: this.state.selectedEmployees,
        divisions: [],
      },
    })
  }

  measureSelectRecipient = (dataTree, idSurveyType) => {
    let response
    if (
      ![
        TYPE_SURVEY.leadership.idSurveyType,
        TYPE_SURVEY.onboarding.idSurveyType,
        TYPE_SURVEY.offboarding.idSurveyType,
      ].includes(idSurveyType)
    ) {
      response = <Loader />
      if (dataTree) {
        response = (
          <MeasurementSelectRecipient
            setStateFrom={this.setStateFrom}
            idMeasurement={this.state.idMeasurement}
            measure={this.props.measure}
            {...pick(this.props, [
              "divisions",
              "getDescendantsWatcher",
              "descendents",
              "isLoadingDescendents",
              "stepTwoWatcher",
              "getDivisionsWatcher",
              "stepRecipientsWatcher",
              "recipientsStepData",
              "isLoadingRecipientsStepData",
              "secondStepData",
            ])}
          />
        )
      }
    } else {
      response = idSurveyType !== 2 && (
        <MeasureSelectRecipientsSegments
          {...this.props}
          selectedEmployees={this.state.selectedEmployees}
          saveRecipients={this.saveRecipients}
          setStateFrom={this.setStateFrom}
          idSurveyType={idSurveyType}
        />
      )
    }

    return response
  }

  isDisabledButton = () => {
    return (
      this.state.firstStepValidation ||
      this.disableNextStep() ||
      this.validateFields() ||
      this.props.isLoadingMailStepData ||
      this.props.isLoadingRecipientsStepData ||
      this.props.isLoadingDatacheckStepData ||
      this.props.isLoadingScheduleStepData ||
      this.props.isLoadingPreviewStepData ||
      this.props.isLoadingForceSaveData
    )
  }


  nextButton = (currentStep) => {
    return (
      <Button
        type="primary"
        disabled={this.isDisabledButton()}
        id={
          this.props.measure.id_scope_type === 1
            ? currentStep === 4
              ? "btnFinalizar"
              : "btnSiguiente"
            : currentStep === 5
            ? "btnFinalizar"
            : "btnSiguiente"
        }
        onClick={() => {
          if (currentStep === 0) {
            this.saveMeasure()
          }

          if (
            currentStep === 2 &&
            this.props.measure.id_scope_type === 1
          ) {
            this.props.forceSaveWatcher({
              idMeasurement: this.state.idMeasurement,
            })
          }

          if (
            currentStep === 2
            /* && this.props.measure.id_scope_type === 2 */
          ) {
            this.props.stepRecipientsWatcher({
              idMeasurement: this.state.idMeasurement,
              params: {
                auto_save: false,
                employees: this.state.selectedEmployees,
                divisions: [],
              },
            })

            /* this.props.forceSaveWatcher({
              idMeasurement: this.state.idMeasurement,
            }) */
          }

          if (this.props.measure.id_scope_type === 1) {
            if (currentStep === 4) {
              this.setStateFrom("modalButtonFinish", true)
              woopraTrack("Finalizar creación de medición")
              this.programmOrEditMeasureSegment()
              return this.props.stepCompleteWatcher(
                this.state.stepFourthReSend
              )
            }
          }

          if (this.props.measure.id_scope_type === 2) {
            if (currentStep === 3) {
              let datacheckbody = {
                auto_save: true,
                recipients_surveys: [],
              }
              let recipients = []
              this.state.employeesAndSurveys.forEach((item) => {

                let record = {id_employee: item.id_employee}

                if (item.id_survey) {
                  record.id_survey = item.id_survey
                } else if (item.id_segment){
                  record.id_segment = item.id_segment
                }

                recipients.push(record)
              })

              datacheckbody.recipients_surveys = recipients

              this.props.stepDatacheckWatcher({
                idMeasurement: this.props.measure.id_measure,
                params: datacheckbody,
              })
            }

            if (currentStep === 5) {
              this.setStateFrom("modalButtonFinish", true)
              woopraTrack("Finalizar creación de medición")
              this.programmOrEditMeasureSegment()
              return this.props.stepCompleteWatcher(
                this.state.stepFourthReSend
              )
            }
          }

          this.nextStep(1)
        }}>
        {this.props.measure.id_scope_type === 1 ? (
          currentStep === 4 ? (
            this.props.measure.id_measure_status == 1 ? (
              "Finalizar"
            ) : (
              "Guardar"
            )
          ) : (
            <React.Fragment>
              Siguiente <RightOutlined style={{ marginLeft: 8 }} />
            </React.Fragment>
          )
        ) : currentStep === 5 ? (
          this.props.measure.id_measure_status == 1 ? (
            "Finalizar"
          ) : (
            "Guardar"
          )
        ) : (
          <React.Fragment>
            Siguiente <RightOutlined style={{ marginLeft: 8 }} />
          </React.Fragment>
        )}
      </Button>
    )
  }

  render() {
    const { currentStep } = this.state
    const { measure, divisions } = this.props

    const idSurveyType = get(measure, "id_survey_type", 1)
    const idScopeType = get(measure, "id_scope_type", 1)
    const dataTree = get(divisions, "dataTree", false)
    const hasFreshchat =
      typeof window.Intercom !== "undefined" &&
      window.self === window.top;
    return (
      <React.Fragment>
        <Helmet>
          <title>Encuestas - Mediciones</title>
          <meta name="description" content="Description of MeasurementCreate" />
          {/* <link rel="stylesheet" href="//cdn.quilljs.com/1.2.6/quill.snow.css" /> */}
          <style>{`
            .ant-calendar-picker-container.ant-calendar-picker-container-placement-bottomLeft .ant-calendar-input-wrap {
              display: block;
            }

            .ant-calendar-picker-container.ant-calendar-picker-container-placement-bottomLeft .ant-calendar-body {
              height: auto !important;
              overflow: auto;
            }
          `}</style>
        </Helmet>
        <div className="measurement-create">
          <div
            className="measurement-create-btn-back"
            onClick={() => {
              woopraTrack("Volver al historial de mediciones")
              this.setStateFrom("modalButtonBackHistory", true)
            }}>
            <LeftOutlined /> Historial de mediciones
          </div>
          <div className="measurement-create-header">
            <div className="measurement-create-header-title">
              <span>Nueva medición:</span>
              {this.props.measure.name}
            </div>
            {currentStep !== 0 && (
              <div className="measurement-create-header-actions">
                {currentStep !== 2 && (
                  <React.Fragment>
                    <div className="loader-autosave-container">
                      {this.renderAutosaveLoader()}
                    </div>
                    <Button
                      onClick={() => {
                        woopraTrack("Previsualizar Medición")
                        window.open(
                          `${process.env.QUESTIONNAIRE_URL}surveys/answers/${
                            this.props.measure.id_scope_type === 1
                              ? this.props.measure.id_survey
                              : this.props.measure.surveys[0].id_survey
                          }`,
                          "_blank"
                        )
                      }}>
                      <img src={previewIcon} /> Previsualizar
                    </Button>
                    <Button
                      onClick={() => {
                        woopraTrack("Enviar Prueba de Medición")
                        this.setStateFrom("modalSendTestSurvey", true)
                      }}>
                      <img src={sendProofIcon} /> Enviar prueba
                    </Button>
                  </React.Fragment>
                )}
              </div>
            )}
          </div>
          <div className="measurement-create-steps">
            <Steps current={currentStep}>
              <Step title="Configurar medición" />
              <Step title="Configurar correo" />
              <Step title="Seleccionar destinatarios" />
              {this.props.measure.id_scope_type === 2 && (
                <Step title="Data check" />
              )}
              <Step title="Previsualizar" />
              <Step title="Agendar encuesta" />
            </Steps>
          </div>


          {/* CONTENT */}
          <div className="measurement-create-content">
            {currentStep === 0 && this.props.isLoadingMeasure && <Loader />}
            {(this.props.isLoadingForceSaveData ||
              this.props.isLoadingMailStepData ||
              this.props.isLoadingRecipientsStepData ||
              this.props.isLoadingDatacheckStepData ||
              this.props.isLoadingScheduleStepData ||
              this.props.isLoadingPreviewStepData) && <Loader />}
            {currentStep === 0 && !this.props.isLoadingMeasure && (
              <MeasureEdit
                setStateFrom={this.setStateFrom}
                selectedSegments={this.state.selectedSegments}
                segmentsAndSurveys={this.state.segmentsAndSurveys}
                nameMeasure={this.state.nameMeasure}
                surveyType={this.state.surveyType}
                scopeType={this.state.scopeType}
                measureType={this.state.measureType}
                selectedSurvey={this.state.selectedSurvey}
                {...this.props}
              />
            )}
            {currentStep === 1 && !this.props.isLoadingForceSaveData && (
              <MailConfiguration
                setStateFrom={this.setStateFrom}
                {...pick(this.props, ["history", "match"])}
              />
            )}
            {currentStep === 2 && idScopeType === 2 && idSurveyType !== 2 && (
              <MeasureSelectRecipientsSegments
                {...this.props}
                selectedEmployees={this.state.selectedEmployees}
                saveRecipients={this.saveRecipients}
                setStateFrom={this.setStateFrom}
                idSurveyType={idSurveyType}
              />
            )}
            {currentStep === 2 && idScopeType === 2 && idSurveyType === 2 && (
              <SelectLeadershipRecipients
                measure={this.props.measure}
                getLeadersWatcher={this.props.getLeadersWatcher}
                getLeaders={this.props.getLeaders}
                isLoadingGetLeaders={this.props.isLoadingGetLeaders}
                secondStepData={this.props.recipientsStepData}
                isLoadingSecondStepData={this.props.isLoadingRecipientsStepData}
                stepTwoWatcher={this.props.stepRecipientsWatcher}
                idMeasurement={this.state.idMeasurement}
                setStateFrom={this.setStateFrom}
              />
            )}

            {currentStep === 2 && idScopeType === 1 && idSurveyType === 2 && (
              <SelectLeadershipRecipients
                measure={this.props.measure}
                getLeadersWatcher={this.props.getLeadersWatcher}
                getLeaders={this.props.getLeaders}
                isLoadingGetLeaders={this.props.isLoadingGetLeaders}
                secondStepData={this.props.recipientsStepData}
                isLoadingSecondStepData={this.props.isLoadingRecipientsStepData}
                stepTwoWatcher={this.props.stepRecipientsWatcher}
                idMeasurement={this.state.idMeasurement}
                setStateFrom={this.setStateFrom}
              />
            )}
            {currentStep === 2 &&
              idScopeType === 1 &&
              this.measureSelectRecipient(dataTree, idSurveyType)}
            {currentStep === 3 &&
              this.props.measure.id_scope_type === 2 &&
              !this.props.isLoadingRecipientsStepData &&
              !this.props.isLoadingForceSaveData && (
                <MeasureDataCheck
                  {...this.props}
                  setStateFrom={this.setStateFrom}
                  employeesAndSurveys={this.state.employeesAndSurveys}
                />
              )}
            {currentStep === 3 && this.props.measure.id_scope_type === 1 && (
              <MeasurementPreview
                handleModalChange={this.setStateFrom}
                isSelected={this.isPrevieworSend}
                {...pick(this.props, ["measure"])}
              />
            )}
            {currentStep === 4 && this.props.measure.id_scope_type === 2 && (
              <MeasurementPreview
                handleModalChange={this.setStateFrom}
                isSelected={this.isPrevieworSend}
                {...pick(this.props, ["measure"])}
              />
            )}
            {/* !this.props.isLoadingFourthStepData */}
            {currentStep === 4 &&
            this.props.measure.id_scope_type === 1 &&
            // (has(this.props.scheduleStepData, "date_start") &&
            typeof this.props.measure.id_measure !== "undefined" ? (
              <MeasurementScheduleSurvey
                setStateFrom={this.setStateFrom}
                idMeasurement={this.state.idMeasurement}
                saveChangeSegment={this.saveSettingSegment}
                fourthStepData={this.props.scheduleStepData}
                stepFourthWatcher={this.props.stepScheduleWatcher}
                // {...pick(this.props, ["fourthStepData", "stepFourthWatcher"])}
              />
            ) : (
              <></>
            )}

            {currentStep === 5 &&
            this.props.measure.id_scope_type === 2 &&
            // (has(this.props.scheduleStepData, "date_start") &&
            typeof this.props.measure.id_measure !== "undefined" ? (
              <MeasurementScheduleSurvey
                setStateFrom={this.setStateFrom}
                idMeasurement={this.state.idMeasurement}
                saveChangeSegment={this.saveSettingSegment}
                fourthStepData={this.props.scheduleStepData}
                stepFourthWatcher={this.props.stepScheduleWatcher}
                // {...pick(this.props, ["fourthStepData", "stepFourthWatcher"])}
              />
            ) : (
              <></>
            )}
          </div>

          <div className="measurement-create-steps-actions">
            <div>
              {currentStep !== 0 && (
                <Button onClick={() => this.nextStep(-1)}>
                  <LeftOutlined /> Anterior
                </Button>
              )}
            </div>
            <div style={{ ...(typeof window.Intercom !== "undefined" &&
            window.self === window.top && {
            marginRight: "61px"}) }}>
              {!this.isDisabledButton()
                ?
                  this.nextButton(currentStep)
                :
                <Popover placement="topLeft" content={() => {
                  return currentStep === 2 ?
                    <span>Es necesario seleccionar al<br /> menos una división para<br /> continuar con el proceso.</span>
                    :
                    <span>Es necesario completar todos<br/> los campos para continuar<br/> con el proceso.</span>
                  }}>
                  {this.nextButton(currentStep)}
                </Popover>
            }
            </div>

          </div>

          {/* BACK TO HISTORY MEASUREMENT */}
          <ModalCustom
            showFooter
            textButton="Salir"
            modalOpen={this.state.modalButtonBackHistory}
            action="Volver a Historial de mediciones"
            onCancel={() => {
              this.setStateFrom("modalButtonBackHistory", false)
              buttonAction_btns("Cancelar Salir de creación de mediciones")
            }}
            onOk={() => {
              this.props.history.push("/models/measure-history")
            }}>
            <img src={alertSvg} className="alertIcon" />
            <p style={{ fontSize: 14, fontWeight: 600 }}>
              ¿Estás seguro de que deseas salir?
            </p>
            <p style={{ fontSize: 13 }}>
              Se perderán los últimos cambios que no hayan sido guardados.
            </p>
          </ModalCustom>

          {/* FINISH */}
          <ModalCustom
            showOnlyAccept
            isLoadingButton={this.props.isLoadingCompleteStepData}
            modalOpen={this.state.modalButtonFinish}
            // onCancel={() => { this.setState({ modalButtonFinish: false}) }}
            onOk={() => {
              if (this.props.measure.id_measure_status == 1) {
                this.props.history.push("/models/measure-history")
              } else {
                this.props.history.goBack()
              }
            }}
            title={false}>
            <img src={check} height={40} />
            <span style={{ fontSize: 14, fontWeight: 600 }}>
              La medición ha sido{" "}
              {this.props.measure &&
                (this.props.measure.id_measure_status == 1
                  ? "creada"
                  : "actualizada")}{" "}
              con éxito.
            </span>
            <p style={{ fontSize: 13, marginTop: 8 }}>
              Podrás visualizar su estado en todo momento desde la sección
              Historial de Mediciones.
            </p>
          </ModalCustom>
        </div>

        <ModalSendTestSurvey
          modalSendTestSurvey={this.state.modalSendTestSurvey}
          setStateFrom={this.setStateFrom}
          {...pick(this.props, ["match", "stepThirdWatcher"])}
        />
        <ModalEditMeasure
          selectSurvey
          visible={this.state.modalEditMeasure}
          setStateFrom={this.setStateFrom}
          measure={this.props.firstStepData}
          {...pick(this.props, [
            "surveysType",
            "isLoadingSurveysType",
            "nameMeasurement",
            "match",
            "editMeasurementNameWatcher",
          ])}
        />
      </React.Fragment>
    )
  }
}

MeasurementCreate.propTypes = { getDivisionsWatcher: PropTypes.func.isRequired }

const mapStateToProps = createStructuredSelector({
  isLoadingDivisions: makeSelectIsLoadingDivisions(),
  divisions: makeSelectDivisions(),
  isLoadingDescendents: makeSelectIsLoadingDescendents(),
  descendents: makeSelectDescendents(),
  logoUrl: makeSelectLogoUrl(),
  isLoadingLogoUrl: makeSelectIsLoadingLogoUrl(),
  isLoadingImageUrl: makeSelectIsLoadingImageUrl(),
  imageUrl: makeSelectImageUrl(),

  firstStepData: makeSelectFirstStepData(),
  isLoadingFirstStepData: makeSelectIsLoadingFirstStepData(),
  secondStepData: makeSelectSecondStepData(),
  isLoadingSecondStepData: makeSelectIsLoadingSecondStepData(),
  nameMeasurement: makeSelectNameMeasurement(),
  fourthStepData: makeSelectFourthStepData(),
  isLoadingFourthStepData: makeSelectIsLoadingFourthStepData(),
  getLeaders: makeSelectGetLeaders(),
  isLoadingGetLeaders: makeSelectIsLoadingGetLeaders(),
  isLoadingSurveysType: makeSelectIsLoadingSurveysType(),
  surveysType: makeSelectSurveysType(),

  mailStepData: makeSelectMailStepData(),
  isLoadingMailStepData: makeSelectIsLoadingMailStepData(),
  recipientsStepData: makeSelectRecipientsStepData(),
  isLoadingRecipientsStepData: makeSelectIsLoadingRecipientsStepData(),
  datacheckStepData: makeSelectDataCheckStepData(),
  isLoadingDatacheckStepData: makeSelectIsLoadingDataCheckStepData(),
  previewStepData: makeSelectPreviewStepData(),
  isLoadingPreviewStepData: makeSelectIsLoadingPreviewStepData(),
  scheduleStepData: makeSelectScheduleStepData(),
  isLoadingScheduleStepData: makeSelectIsLoadingScheduleStepData(),
  completeStepData: makeSelectCompleteStepData(),
  isLoadingCompleteStepData: makeSelectIsLoadingCompleteStepData(),
  forceSaveData: makeSelectForceSaveData(),
  isLoadingForceSaveData: makeSelectIsLoadingForceSaveData(),

  employeesBySegments: makeSelectEmployeesBySegments(),
  isLoadingEmployeesBySegments: makeSelectIsLoadingEmployeesBySegments(),

  measure: makeSelectGetMeasure(),
  isLoadingMeasure: makeSelectIsLoadingMeasure(),
  isLoadingUpdateMeasure: makeSelectIsLoadingUpdateMeasure(),
  segments: makeSelectSegments(),
  isLoadingSegments: makeSelectIsLoadingSegments(),
  surveyTypes: makeSelectSurveyTypes(),
  isLoadingSurveyTypes: makeSelectIsLoadingSurveyTypes(),
  scopeTypes: makeSelectScopeTypes(),
  isLoadingScopeTypes: makeSelectIsLoadingScopeTypes(),
  organizationSurveys: makeSelectOrganizationSurveys(),
  isLoadingOrganizationSurveys: makeSelectIsLoadingOrganizationSurveys(),
  segmentsSurveys: makeSelectSegmentsSurveys(),
  isLoadingSegmentsSurveys: makeSelectIsLoadingSegmentsSurveys(),
})

function mapDispatchToProps(dispatch) {
  return {
    getSurveysTypeWatcher: (params) => dispatch(getSurveysTypeWatcher(params)),
    getDivisionsWatcher: (params) => dispatch(getDivisionsWatcher(params)),
    getDescendantsWatcher: (params) => dispatch(getDescendantsWatcher(params)),
    // postLogoEmailWatcher: params => dispatch(postLogoEmailWatcher(params)),
    // postImageEmailWatcher: params => dispatch(postImageEmailWatcher(params)),
    stepOneWatcher: (params) => dispatch(stepOneWatcher(params)),
    stepTwoWatcher: (params) => dispatch(stepTwoWatcher(params)),
    stepThirdWatcher: (params) => dispatch(stepThirdWatcher(params)),
    stepFourthWatcher: (params) => dispatch(stepFourthWatcher(params)),
    stepFinishWatcher: (params) => dispatch(stepFinishWatcher(params)),
    stepMailWatcher: (params) => dispatch(stepMailWatcher(params)),
    stepRecipientsWatcher: (params) => dispatch(stepRecipientsWatcher(params)),
    stepDatacheckWatcher: (params) => dispatch(stepDatacheckWatcher(params)),
    stepPreviewWatcher: (params) => dispatch(stepPreviewWatcher(params)),
    stepScheduleWatcher: (params) => dispatch(stepScheduleWatcher(params)),
    stepCompleteWatcher: (params) => dispatch(stepCompleteWatcher(params)),
    forceSaveWatcher: (params) => dispatch(forceSaveWatcher(params)),
    getEmployeesBySegmentsWatcher: (params) =>
      dispatch(getEmployeesBySegmentsWatcher(params)),
    editMeasurementNameWatcher: (params) =>
      dispatch(editMeasurementNameWatcher(params)),
    stepOneSuccess: (params) => dispatch(stepOneSuccess(params)),
    postLogoEmailSuccess: (params) => dispatch(postLogoEmailSuccess(params)),
    postImageEmailSuccess: (params) => dispatch(postImageEmailSuccess(params)),
    getLeadersWatcher: (params) => dispatch(getLeadersWatcher(params)),
    getMeasureWatcher: (params) => dispatch(getMeasureWatcher(params)),
    updateMeasureWatcher: (params) => dispatch(updateMeasureWatcher(params)),
    getSegmentsWatcher: (params) => dispatch(getSegmentsWatcher(params)),
    getSurveyTypesWatcher: (params) => dispatch(getSurveyTypesWatcher(params)),
    getScopeTypesWatcher: (params) => dispatch(getScopeTypesWatcher(params)),
    getOrganizationSurveysWatcher: (params) =>
      dispatch(getOrganizationSurveysWatcher(params)),
    getSegmentsSurveysWatcher: (params) =>
      dispatch(getSegmentsSurveysWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "measurementCreate", reducer })
const withSaga = injectSaga({ key: "measurementCreate", saga })

export default compose(withReducer, withSaga, withConnect)(MeasurementCreate)
